<template>
  <div class="content">
    <div class="content-img">
      <van-image :src="require('@/assets/img/newSuccess.png')"></van-image>
    </div>
    <div class="text-father">
      <div class="success-title">提交成功</div>
      <div class="success-desc">
        我们已经收到您的反馈，我们会尽快处理。如有需要，我们会通过电话联系您，您也可以通过<span class="phone-number">0571-86071799</span>直接联系我们。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  created() {
    // this.$httpAI({
    //   url: this.$httpAI.adornUrl('/problem/hasNew'),
    //   method: 'get'
    // }).then(({data}) => {
    //   if (data && data.code === 0) {
    //
    //   } else {
    //     this.$toast.fail(data.msg)
    //   }
    // })
  },
  methods: {

  }

}
</script>

<style scoped>
.content {
  height: 100vh !important;
  width: 100vw !important;
  background-color: white;
  padding-top: 120px;
  box-sizing: border-box;
}
.content-img {
  width: 300px;
  height: 300px;
  margin: 0 auto;
}
.x-close-dialog {
  font-size: 0.6rem;
  text-align: right;
  padding: 0.3rem 0.4rem 0 0
}
.text-father {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 40px;
  margin-top: 40px;
}

.success-title {
  font-size: 0.8rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  letter-spacing: 1px;
}

.success-desc {
  font-size: 0.5rem;
  color: #666;
  line-height: 1.8;
  text-align: center;
  max-width: 90%;
}

.phone-number {
  color: #4581F8;
  font-weight: 500;
  cursor: pointer;
}
</style>
